import React, { useEffect, useRef } from "react";
import { Row } from "reactstrap";
import ProjectCard from "./ProjectCard";
import { projectsArray } from "./ProjectsArray.js";
//import { motion } from "framer-motion/dist/framer-motion";

import "./Projects.css";

const Projects = (props) => {
  const myRef = useRef(null);

  useEffect(() => {
    if (props.sd === "projects") {
      myRef.current.scrollIntoView();
    }
  }, [props.sd]);

  return (
    <div
      ref={myRef}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1
        style={{
          color: "black",
          fontSize: "50px",
          fontWeight: "bold",
          color: "#155BDD",
          marginTop: "50px",
          fontFamily: "Tenorite",
        }}
      >
        PROJECTS
      </h1>
      <br />
      <Row
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "20px",
          flexWrap: "wrap",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        {projectsArray.map((proj) => (
          <ProjectCard
            imageUrl={proj.imageUrl}
            title={proj.title}
            content={proj.content}
            stack={proj.stack}
            sourceCode={proj.sourceCode}
          />
        ))}
      </Row>
    </div>
  );
};

export default Projects;
